module.exports = __webpack_public_path__ + "img/callnumber-poster-bg-general.07541de3.png";